import { AiAPI } from "@radarly/api/ai";
import { DatavizTypeAI } from "@radarly/models/dataviz";
import { AIFragment } from "@radarly/models/search";
import { AiRepo } from "./AiRepo";

interface Dependencies {
  ai: AiAPI;
}

export class ConnectedAiRepo implements AiRepo {
  api: AiAPI;
  public constructor(dependencies: Dependencies) {
    this.api = dependencies.ai;
  }
  public getAISummary<T extends DatavizTypeAI>(
    pid: number,
    searchFragmentAI: AIFragment & { analysis: { type: T } }
  ) {
    return this.api.getAIFocus(pid, searchFragmentAI);
  }
}
